<template>
  <ConfigProvider :dir="useDirectionStore.getDirection">
    <div
      class="h-[100dvh] landscape:h-screen flex max-md:flex-col m-0 p-0 ltr:bg-gradient-to-tr rtl:bg-gradient-to-tl from-[#0D4B9B] to-[#0683FF] overflow-hidden"
    >
      <Navigation>
        <div class="flex flex-col grow md:p-3 ltr:md:pl-0 rtl:md:pr-0 md:gap-4">
          <div
            class="relative flex flex-col grow bg-primary md:rounded-xl shadow-xs overflow-hidden"
          >
            <!-- Page Content -->
            <slot />
            <ActionButton
              v-if="maxSmall"
              :type="type"
              class="absolute ltr:right-2 rtl:left-2 bottom-2 z-20"
            />
          </div>
        </div>
      </Navigation>
    </div>
    <Toaster position="top-center" closeButton @pointerdown.stop />
    <TrialCountdown />
  </ConfigProvider>
</template>

<script setup>
import { computed, watch } from "vue";
import { ConfigProvider } from "radix-vue";
import { usePage } from "@inertiajs/vue3";
import { FilterType } from "@/SharedComponents/Filters";
import { ActionButton, Navigation } from "@/SharedComponents/Navigation";
import TrialCountdown from "@/Tailwind/Components/TrialCountdown.vue";
import { Toaster } from "@/SharedComponents/Toaster";
import { usePreloadStore } from "@/Tailwind/Stores/preload";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { useFilters } from "@/Composables/useFilters";
import { useSites as useBuildings } from "@/Composables/useSites";
import { directionStore } from "@/Stores/direction";

const useDirectionStore = directionStore();

const { isLoading, data: buildings } = useBuildings();

const hasOnlyOneBuilding = computed(() => {
  if (isLoading.value) {
    return false;
  }
  return buildings.value.length === 1;
});

const filterStore = useFilters("global");
const { handleChangeFilter } = filterStore;

watch(
  () => hasOnlyOneBuilding.value,
  () => {
    if (hasOnlyOneBuilding.value) {
      handleChangeFilter(FilterType.LINKED_TO, {
        buildings: [buildings.value[0].id],
      });
    }
  }
);

const { maxSmall } = useBreakpoints();

const type = computed(() => {
  switch (true) {
    case usePage().url.includes("/admin/tasks"):
      return "task";
    case usePage().url.includes("/admin/files"):
      return "file";
    case usePage().url.includes("/admin/assets"):
      return "asset";
    case usePage().url.includes("/admin/asset-groups"):
      return "asset_group";
    case usePage().url.includes("/admin/spaces"):
      return "space";
    case usePage().url.includes("/admin/settings/organisation/recurring-tasks"):
      return "recurring_task";
    default:
      return undefined;
  }
});

const preloadStore = usePreloadStore();
preloadStore.loadLocations();
preloadStore.loadCategories();
preloadStore.loadUsers();
preloadStore.loadAssets();
</script>
